export default class inputFile {
    constructor() {
        this.fileInput = document.querySelector('.default-input--file')
        if(!this.fileInput) return
        this.placeholder = this.fileInput.querySelector('.default-input__placeholder')
        this.init()
    }

    init() {
        this.fileInput.value = null
        this.fileInput.addEventListener('change', (event) => {
            if((event.target.files[0].size / 1024 / 1024) < 10) {
                let fileName = event.target.files[0].name

                this.placeholder.innerHTML = fileName
                this.placeholder.classList.add('active')
            }
            else {
                this.fileInput.value = null
                alert('Размер файла не может превышать 10 Мб')
            }
        });        
    }

}